<!--
NOTE: We have to add 'cdkDropListGroup' here on the parent to allow children that are marked with 'cdkDropList'
extending items via Drag&Drop with each other
-->

@if (template$ | async; as template) {
  <div class="template-editor">
    <div class="control-panel">
      <button
        rotec-button-active
        bullet
        (click)="saveReportTemplate(template)"
        icon="check"
        [disabled]="!canSave(template) || (saveButtonDisabled$ | async)"
      >
        {{ 'SaveEdit' | translate }}
      </button>
      <button
        rotec-button-secondary
        bullet
        (click)="exportReportPreview(template, toolboxSettings)"
        icon="watch"
        [disabled]="!canExportReportPreview(template)"
      >
        {{ 'PreviewEdit' | translate }}
      </button>
      <button
        rotec-button-warning-unfilled
        bullet
        (click)="cancelReportTemplate()"
        icon="close"
        translate
      >
        {{ 'CancelEdit' | translate }}
      </button>
    </div>
    <div cdkDropListGroup class="editor-container">
      <!-- Preview Area -->
      <div class="editor">
        <mat-tab-group [selectedIndex]="indexOfSelectedPage" class="hide-tab-header">
          @for (page of template.pages; track page; let i = $index) {
            <mat-tab>
              <rc-template-canvas
                [(page)]="template.pages[i]"
                (pageChange)="onTemplateChanged()"
              ></rc-template-canvas>
            </mat-tab>
          }
        </mat-tab-group>
      </div>
      <!-- Toolbox Area -->
      <div class="toolbox-container">
        <div
          [rotecStickyElement]="toolboxContainer"
          [stickyInfo]="{ offset: 1, offsetTo: 'top', position: 'absolute' }"
        >
          <mat-card appearance="outlined" class="transparent-border card">
            <div>
              <!-- Title -->
              <rotec-text-input-v2
                [(value)]="template.name"
                (valueChange)="onTemplateChanged()"
                [required]="true"
                min="0"
                max="50"
                placeholder="{{ 'templateTitle' | translate }}"
                class="highlight-required"
              >
              </rotec-text-input-v2>
              <!-- Toolbox-->
              <rc-template-toolbox
                [userDefinedFields]="template.userDefinedFields"
                [(config)]="template.config"
                (configChange)="onTemplateChanged()"
                (settings)="settingsChanged($event)"
              ></rc-template-toolbox>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
}
